
import template from './poster-preview-form-dialog.html';

const mapStateToThis = ({ session, config, mediaTemplates }) => {
  const { locale } = session;
  const { locales } = config;
  const { entries } = mediaTemplates;

  return {
    locale,
    locales,
    entries,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$filter')
class PosterPreviewFormDialogController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  async $onInit() {
    this.posterParams = {
      serviceType: 'print',
      locale: this.locale,
    };
    this.isGameNoAvailable = this.isPosterElementAvailable('LOGO');
    this.isAmountAvailable = this.isPosterElementAvailable('AMOUNT');
    this.isDateAvailable = this.isPosterElementAvailable('DATE');
    this.isRetailerNoAvailable = this.isPosterElementAvailable('RETAILERINFO');
  }

  $onDestroy() {
    this.unsubscribe();
  }

  isPosterElementAvailable(elementType) {
    return !!this.entries[0].posterConfigElements
      .find((posterConfigElement) => posterConfigElement.elementType === elementType);
  }

  handleCloseDialog() {
    const amount = this.$filter('currency')(this.posterParams.amount, undefined, 0);
    const date = this.$filter('date')(new Date('December 31, 1988 00:00:00'), 'shortDate');


    let posterParams = {
      ...this.posterParams,
      amount,
    };

    if (this.isDateAvailable) {
      posterParams = {
        ...this.posterParams,
        amount,
        date,
      };
    }

    this.close({ $value: posterParams });
  }
}

export default class PosterPreviewFormDialogComponent {
  constructor() {
    this.controller = PosterPreviewFormDialogController;
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/media-templates/components/poster-preview-form/poster-preview-form-dialog-component.js